import { Component, AfterViewInit, ElementRef, Renderer2, ViewChild, Input, SimpleChanges, OnChanges, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-d4sign-frame',
  templateUrl: './d4sign-frame.component.html',
  styleUrls: ['./d4sign-frame.component.scss']
})
export class D4signFrameComponent implements AfterViewInit, OnChanges, OnDestroy, OnInit {

  signerDisplayName: string = '';
  signerDocumentation: string = '';
  signerBirthday: string = '';
  signerKeySigner: string = '';
  signerDisablePreview: string = '';

  idUrlAleatorioUrl: string = '';
  documentoUuidUrl: string = '';
  cccUrl: string = '';
  emailUrl: string = '';

  @ViewChild('signatureDiv', { static: true }) signatureDiv!: ElementRef;

  constructor(
    private route: ActivatedRoute,
    private renderer: Renderer2,
    private router: Router) { }


  // ✅ Callback atualizado com validação de origem e navegação
  private messageListener = (event: MessageEvent) => {
    const trustedOrigin = 'https://secure.d4sign.com.br';
    if (event.origin !== trustedOrigin) {
      console.warn(`Mensagem ignorada por origem não confiável: ${event.origin}`);
      return;
    }

    if (event.data === 'signed') {
      this.router.navigate(['/assinatura-concluida']); // 🚀 ajuste conforme sua rota
    } else if (event.data === 'wrong-data') {
      this.router.navigate(['/corrigir-dados']); // 🚀 ajuste conforme sua rota
    }
  };


  ngOnInit(): void {
    this.idUrlAleatorioUrl = this.route.snapshot.paramMap.get('id') ?? '';
    this.documentoUuidUrl = this.route.snapshot.queryParamMap.get('documentouuid') ?? '';
    this.cccUrl = this.route.snapshot.queryParamMap.get('Ccc') ?? '';
    this.emailUrl = this.route.snapshot.queryParamMap.get('email') ?? '';
  }

  ngAfterViewInit(): void {
    this.renderIframe();
    window.addEventListener('message', this.messageListener);
  }

  ngOnChanges(changes: SimpleChanges): void {
    // Re-renderiza apenas se o componente já foi inicializado
    if (this.signatureDiv?.nativeElement) {
      this.renderIframe();
    }
  }

  ngOnDestroy(): void {
    window.removeEventListener('message', this.messageListener);
  }

  private renderIframe(): void {
    const host = 'https://secure.d4sign.com.br/embed/viewblob';
    const width = '100%';
    const height = '600px';
    const container = this.signatureDiv.nativeElement;

    const existingIframe = container.querySelector('iframe');
    if (existingIframe) {
      this.renderer.removeChild(container, existingIframe);
    }

    // Limpa o conteúdo anterior
    this.renderer.setProperty(container, 'innerHTML', '');

    // Safari fix
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    if (isSafari && !document.cookie.includes('fixed=')) {
      document.cookie = 'fixed=fixed; expires=Tue, 19 Jan 2038 03:14:07 UTC; path=/';
      let url = document.URL;
      const param = window.location.search.replace('?', '');
      if (url.indexOf('?') > -1) {
        url = url.split('?')[0];
      }
      window.location.replace(`https://secure.d4sign.com.br/embed/safari_fix?param=${param}&r=${url}`);
      return;
    }

    // Criação do iframe
    const iframe = this.renderer.createElement('iframe');

    const cacheBuster = Date.now();
    const baseUrl = `${host}/${this.documentoUuidUrl}?email=${encodeURIComponent(this.emailUrl)}&display_name=${encodeURIComponent(this.signerDisplayName)}&documentation=${encodeURIComponent(this.cccUrl)}&birthday=${encodeURIComponent(this.signerBirthday)}&disable_preview=${encodeURIComponent(this.signerDisablePreview)}`;

    const finalUrl = this.signerKeySigner
      ? `${baseUrl}&key_signer=${this.signerKeySigner}&nonce=${cacheBuster}`
      : `${baseUrl}&nonce=${cacheBuster}`;

    this.renderer.setAttribute(iframe, 'src', finalUrl);
    this.renderer.setAttribute(iframe, 'id', 'd4signIframe');
    this.renderer.setAttribute(iframe, 'width', width);
    this.renderer.setAttribute(iframe, 'height', height);
    this.renderer.setStyle(iframe, 'border', '0');
    this.renderer.setAttribute(iframe, 'allow', 'geolocation');

    this.renderer.appendChild(container, iframe);
  }

  
}